import { getLocalStore } from 'utils/commonFunc';

export default {
  // API_BASE_URL: 'http://localhost:5001',
  API_BASE_URL: 'https://api.tanacademy.in',
  roles: {
    guardian: 'ROLE_GUARD',
    teacher: 'ROLE_TEACHER',
    admin: 'ROLE_ADMIN',
    SA: 'ROLE_SUPER_ADMIN',
  },
  setHeader: (token, currentUserId, isMutipart, passController) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(currentUserId && { currentUserId }),
        ...(!!isMutipart && { 'Content-Type': 'multipart/form-data' }),
      },
      signal: passController?.signal,
    };
  },
  makeParams: (params, canAppend = false) => {
    if (params) {
      return `${canAppend ? '&' : '?'}${Object.keys(params)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&')}`;
    }
    return '';
  },
};

export const makeFirstCaps = str => {
  if (str && typeof str === 'string') {
    return str?.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
  }
  return '';
};

export const capitalize = str => {
  if (str && typeof str === 'string') {
    return str?.replace(/^./, strItem => `${strItem.toUpperCase()}`);
  }
  return '';
};

export const formStudentName = student => {
  return capitalize(
    `${student?.firstName?.trim()}${
      student?.middleName ? ` ${student?.middleName?.trim()}` : ''
    } ${student?.lastName?.trim()}`
  );
};

export const courseStageList = [
  { label: 'Primary (PreKg - 5th)', value: 'PRIMARY' },
  { label: 'Secondary (6th - 10th)', value: 'SECONDARY' },
  { label: 'Higher Secondary (11th - 12th)', value: 'HIGHER_SECONDARY' },
  { label: 'Diplomo (Course)', value: 'DIPLOMO' },
  { label: 'Degree (Graduate)', value: 'DEGREE' },
  { label: 'General', value: 'GENERAL' },
];
export const courseStages =
  'PRIMARY (PRE_KG - 5th), SECONDARY (6th - 10th), HIGHER_SECONDARY (11th - 12th), DIPLOMO (Course), DEGREE (Graduate), GENERAL';

const commonConfigStore = getLocalStore('commonConfig');
const teacherName = commonConfigStore?.find(el => el.configName === 'LABEL_TEACHER')?.configValue;
const className = commonConfigStore?.find(el => el.configName === 'LABEL_CLASS')?.configValue;
console.log({ teacherName, className });
export let courseStatic = className ? makeFirstCaps(className) : 'Class';
export let coursesStatic = className ? `${makeFirstCaps(className)}s` : 'Classes';
export let employeeStatic = teacherName ? makeFirstCaps(teacherName) : 'Teacher';
export let employeesStatic = teacherName ? `${makeFirstCaps(teacherName)}s` : 'Teachers';
export const MOBILE_APP_URL = 'https://play.google.com/store/apps/details?id=com.scholae';
